import "@shared/lib/tracer";
import "@ant-design/v5-patch-for-react-19";
import { ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "@app/providers";
import "./styles/global.scss";

createRoot(document.getElementById("root")!).render(
  (<Provider />) as ReactNode,
);
